// extracted by mini-css-extract-plugin
export default {"quickTipsButton":"quickTipsButton-sGCDU","quick-tips":"quick-tips-TBdlB","appcues-widget-icon":"appcues-widget-icon-owZjU"};